export enum Party {
    unbekannt = 0,
    CDU = 1,
    CSU = 2,
    Grüne = 3,
    Linke = 4,
    AfD = 5,
    FDP = 6,
    SPD = 7,
    FW = 8,
    Andere = 99
}



// WEBPACK FOOTER //
// ./src/app/enums/party.enum.ts